import HasSlots from './HasSlots';
export default HasSlots;
